import { ADD_BOOK_PUBLISHER } from "../../types/BookPublisherType";
import axios from "axios";
import { toast } from "react-toastify";

const addBookPublisherAction = (data) => {
  return {
    type: ADD_BOOK_PUBLISHER,
    payload: data,
  };
};

export const addBookPublisher = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `book-publisher/`,
        data: {
          ...values,
        },
      });
      //dispatching data
      dispatch(addBookPublisherAction(data));
      toast.success("Publisher Added");
      return {
        message: "success",
        data,
      };
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message === "Publisher already exist."
      ) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
        toast.error("Error in adding publisher, please try again!");
      }

      console.log(error.message);
    }
  };
};
